export const ALL_USERS_GET_SUCCESS = "get/users/all/success";
export const ALL_USERS_GET_LOADING = "get/users/all/loading";
export const ALL_USERS_GET_ERROR = "get/users/all/error";

export const USER_DELETE_SUCCESS = "delete/user/success";
export const USER_DELETE_LOADING = "delete/user/loading";
export const USER_DELETE_ERROR = "delete/user/error";
